module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card text-xs-center"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.product.url,
      "alt": _vm.product.title,
      "width": "220",
      "height": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-overlay top"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background-color": "#fefbf7"
    }
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" " + _vm._s(_vm._f("formatMoney")(_vm.product.price)) + " - Stock:" + _vm._s(_vm.product.inventory))]), _vm._v(" "), _c('add-to-cart', {
    attrs: {
      "product": _vm.product
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb28ebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/products/Product.vue
// module id = 272
// module chunks = 1